import PanelFooter from './panel-footer';

export default PanelFooter;